export default "__VITE_ASSET__Bxd0Dxhv__"